"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9637],{

/***/ 29637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OurProcess": function() { return /* binding */ OurProcess; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
;// CONCATENATED MODULE: ./public/svg/horizontal-wave.svg
var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgHorizontalWave = function SvgHorizontalWave(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 1170 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.54 63.275C193.465 75.71 196 89.04 196 102.5h-1.96c0-13.191-2.484-26.253-7.311-38.44-4.826-12.188-11.9-23.261-20.818-32.589-8.919-9.328-19.506-16.727-31.158-21.775C123.101 4.648 110.612 2.05 98 2.05c-12.612 0-25.1 2.598-36.753 7.646-11.652 5.048-22.24 12.447-31.157 21.775C21.17 40.8 14.097 51.872 9.27 64.06 4.445 76.248 1.96 89.31 1.96 102.5H0c0-13.46 2.535-26.79 7.46-39.225 4.925-12.436 12.143-23.735 21.243-33.253 9.1-9.518 19.904-17.069 31.794-22.22C72.387 2.652 85.13 0 98 0c12.87 0 25.613 2.651 37.503 7.802 11.89 5.152 22.693 12.701 31.793 22.22 9.101 9.518 16.319 20.817 21.244 33.253Zm12.958 78.45A106.124 106.124 0 0 1 194 102.5h1.97a104.01 104.01 0 0 0 7.348 38.441c4.851 12.187 11.961 23.26 20.925 32.588s19.605 16.727 31.317 21.775a93.269 93.269 0 0 0 36.94 7.646 93.265 93.265 0 0 0 36.94-7.646c11.712-5.048 22.353-12.447 31.317-21.775 8.964-9.328 16.074-20.401 20.925-32.588a104.01 104.01 0 0 0 7.348-38.441H389c0-13.46 2.535-26.79 7.46-39.225 4.925-12.436 12.143-23.735 21.244-33.253 9.1-9.518 19.903-17.069 31.793-22.22C461.387 2.652 474.13 0 487 0c12.87 0 25.613 2.651 37.503 7.802 11.89 5.152 22.693 12.701 31.793 22.22 9.101 9.518 16.319 20.817 21.244 33.253C582.465 75.71 585 89.04 585 102.5h-1.96c0-13.191-2.484-26.253-7.311-38.44-4.826-12.188-11.9-23.261-20.818-32.589-8.919-9.328-19.506-16.727-31.158-21.775C512.101 4.648 499.612 2.05 487 2.05c-12.612 0-25.101 2.598-36.753 7.646-11.652 5.048-22.239 12.447-31.158 21.775-8.918 9.328-15.992 20.401-20.818 32.588-4.827 12.188-7.311 25.25-7.311 38.441h.04c0 13.46-2.548 26.789-7.498 39.225s-12.205 23.735-21.352 33.253-20.005 17.069-31.956 22.22A95.172 95.172 0 0 1 292.5 205a95.172 95.172 0 0 1-37.694-7.802c-11.951-5.151-22.809-12.702-31.956-22.22-9.147-9.518-16.402-20.817-21.352-33.253Zm389 0A106.124 106.124 0 0 1 583 102.5h1.97a104.01 104.01 0 0 0 7.348 38.441c4.851 12.187 11.961 23.26 20.925 32.588s19.605 16.727 31.317 21.775a93.265 93.265 0 0 0 36.94 7.646 93.265 93.265 0 0 0 36.94-7.646c11.712-5.048 22.353-12.447 31.317-21.775 8.964-9.328 16.074-20.401 20.925-32.588a104.01 104.01 0 0 0 7.348-38.441H778c0-13.46 2.548-26.79 7.498-39.225 4.95-12.436 12.205-23.735 21.352-33.253s20.005-17.069 31.956-22.22C850.756 2.652 863.565 0 876.5 0c12.935 0 25.744 2.651 37.694 7.802 11.951 5.152 22.809 12.701 31.956 22.22 9.147 9.518 16.402 20.817 21.352 33.253A106.126 106.126 0 0 1 975 102.5h-1.97c0-13.191-2.497-26.253-7.348-38.44-4.851-12.188-11.961-23.261-20.925-32.589S925.152 14.744 913.44 9.696A93.264 93.264 0 0 0 876.5 2.05a93.264 93.264 0 0 0-36.94 7.646c-11.712 5.048-22.353 12.447-31.317 21.775-8.964 9.328-16.074 20.401-20.925 32.588a104.003 104.003 0 0 0-7.348 38.441h.03c0 13.46-2.548 26.789-7.498 39.225s-12.205 23.735-21.352 33.253-20.005 17.069-31.956 22.22A95.172 95.172 0 0 1 681.5 205a95.172 95.172 0 0 1-37.694-7.802c-11.951-5.151-22.809-12.702-31.956-22.22-9.147-9.518-16.402-20.817-21.352-33.253Zm390 0A106.124 106.124 0 0 1 973 102.5h1.97a104.01 104.01 0 0 0 7.348 38.441c4.851 12.187 11.961 23.26 20.922 32.588 8.97 9.328 19.61 16.727 31.32 21.775a93.251 93.251 0 0 0 36.94 7.646c12.68 0 25.23-2.598 36.94-7.646 11.71-5.048 22.35-12.447 31.32-21.775 8.96-9.328 16.07-20.401 20.92-32.588a104.032 104.032 0 0 0 7.35-38.441h1.97c0 13.46-2.55 26.789-7.5 39.225s-12.2 23.735-21.35 33.253c-9.15 9.518-20.01 17.069-31.96 22.22S1084.44 205 1071.5 205c-12.94 0-25.74-2.651-37.69-7.802s-22.81-12.702-31.96-22.22c-9.147-9.518-16.402-20.817-21.352-33.253Z",
    fill: "url(#horizontal-wave_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "horizontal-wave_svg__a",
    x1: 131.23,
    y1: 205,
    x2: 154.517,
    y2: -116.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#0E4ED7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.885,
    stopColor: "#F94743"
  })))));
};
/* harmony default export */ var horizontal_wave = (SvgHorizontalWave);
;// CONCATENATED MODULE: ./public/svg/vertical-wave.svg
var vertical_wave_path, vertical_wave_defs;
function vertical_wave_extends() { vertical_wave_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vertical_wave_extends.apply(this, arguments); }

var SvgVerticalWave = function SvgVerticalWave(props) {
  return /*#__PURE__*/react.createElement("svg", vertical_wave_extends({
    viewBox: "0 0 327 1947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), vertical_wave_path || (vertical_wave_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.112 279.112A163.5 163.5 0 0 1 163.504 327a.004.004 0 0 0-.004.004.004.004 0 0 1-.004.004 160.491 160.491 0 0 0-.997 320.98 1.006 1.006 0 0 1 1.001 1.003V650c0 .552-.449 1-1.001.997A163.502 163.502 0 0 1 0 487.5 163.5 163.5 0 0 1 163.499 324l.001-.001.001-.001a160.497 160.497 0 0 0 1-320.993 1.006 1.006 0 0 1-1.001-1.003V1c0-.552.449-1 1.001-.997a163.5 163.5 0 0 1 114.611 279.109ZM163.5 975.004c0-.002.002-.004.004-.004a163.5 163.5 0 0 0 .997-326.997.996.996 0 0 0-1.001.997v1.008c0 .552.449 1 1.001 1.003a160.492 160.492 0 0 1-.997 320.98c-.002 0-.004.002-.004.005a.004.004 0 0 1-.004.004 163.493 163.493 0 0 0-115.608 47.89 163.497 163.497 0 0 0 0 231.22A163.52 163.52 0 0 0 162.499 1299c.552 0 1.001-.45 1.001-1v-1.01c0-.55-.449-1-1.001-1a160.45 160.45 0 0 1-112.484-47.01A160.475 160.475 0 0 1 3.008 1135.5c0-42.57 16.91-83.39 47.007-113.48a160.475 160.475 0 0 1 113.481-47.012.004.004 0 0 0 .004-.004Zm0 647.996h.004a163.501 163.501 0 0 0 .997-327c-.552 0-1.001.45-1.001 1v1.01c0 .55.449 1 1.001 1a160.451 160.451 0 0 1 112.484 47.01 160.458 160.458 0 0 1 47.007 113.48c0 42.56-16.909 83.39-47.007 113.48a160.478 160.478 0 0 1-113.481 47.01c-.002 0-.004 0-.004.01h-.004a163.502 163.502 0 0 0-115.608 279.11A163.52 163.52 0 0 0 162.499 1947c.552 0 1.001-.45 1.001-1v-1.01c0-.55-.449-1-1.001-1a160.45 160.45 0 0 1-112.484-47.01A160.475 160.475 0 0 1 3.008 1783.5c0-42.57 16.91-83.39 47.007-113.48a160.477 160.477 0 0 1 113.481-47.01c.002 0 .004 0 .004-.01Z",
    fill: "url(#vertical-wave_svg__a)"
  })), vertical_wave_defs || (vertical_wave_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "vertical-wave_svg__a",
    x1: 36.677,
    y1: 1947,
    x2: 1107.52,
    y2: 1511.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#0E4ED7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.885,
    stopColor: "#F94743"
  })))));
};
/* harmony default export */ var vertical_wave = (SvgVerticalWave);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/sections/OurProcess/processStage.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &:after {\n          bottom: 25%;\n          right: -11rem;\n        }\n\n        &:nth-child(1) {\n          grid-row: 2;\n          grid-column: 1;\n        }\n\n        &:nth-child(2) {\n          grid-row: 4;\n          grid-column: 1;\n        }\n\n        &:nth-child(3) {\n          grid-row: 6;\n          grid-column: 1;\n        }\n      "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &:after {\n          bottom: -10rem;\n          right: unset;\n        }\n\n        &:nth-child(1) {\n          grid-row: 1;\n          grid-column: 2;\n        }\n\n        &:nth-child(2) {\n          grid-row: 1;\n          grid-column: 4;\n        }\n\n        &:nth-child(3) {\n          grid-row: 1;\n          grid-column: 6/7;\n        }\n      "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      justify-content: center;\n      flex-direction: column-reverse;\n      &:after {\n        content: '';\n        position: absolute;\n        background-image: url(",
        ");\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 5rem 5rem;\n        display: block;\n        width: 12.313rem;\n        height: 12.313rem;\n      }\n\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &:before {\n          top: 25%;\n          left: -11rem;\n        }\n        &:nth-child(1) {\n          grid-row: 1;\n          grid-column: 1;\n        }\n\n        &:nth-child(2) {\n          grid-row: 3;\n          grid-column: 1;\n        }\n\n        &:nth-child(3) {\n          grid-row: 5;\n          grid-column: 1;\n        }\n      "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        flex-direction: column-reverse;\n        justify-content: flex-end;\n\n        &:before {\n          top: -10rem;\n          left: unset;\n        }\n        &:nth-child(1) {\n          grid-row: 1;\n          grid-column: 1;\n        }\n\n        &:nth-child(2) {\n          grid-row: 1;\n          grid-column: 3;\n        }\n\n        &:nth-child(3) {\n          grid-row: 1;\n          grid-column: 5;\n        }\n      "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex-direction: column-reverse;\n      justify-content: center;\n\n      &:before {\n        content: '';\n        position: absolute;\n        background-image: url(",
        ");\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 5rem 5rem;\n        display: block;\n        width: 12.313rem;\n        height: 12.313rem;\n      }\n\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: -2rem;\n    "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: -2rem;\n    "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    letter-spacing: -0.0125rem;\n    margin-bottom: 1rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 33.4375rem;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.25rem;\n    line-height: 2rem;\n    margin-bottom: 5rem;\n    max-width: 46.4375rem;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 7.5rem;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 60rem;\n    margin: 0 auto;\n  "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 70.89rem;\n  "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}





const StageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1lu622w0"
})("display:flex;flex-direction:column;position:relative;align-items:center;gap:1rem;max-width:13.125rem;", (param)=>{
    let { position , imageUrl  } = param;
    return position === "TOP" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), imageUrl, mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())));
}, " ", (param)=>{
    let { position , imageUrl  } = param;
    return position === "BOTTOM" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject5(), imageUrl, mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())));
}, "  \n  ", (param)=>{
    let { position  } = param;
    return position === "TOP" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject6());
}, "  \n  ", (param)=>{
    let { position  } = param;
    return position === "BOTTOM" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject7());
});
const ProcessStageText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1lu622w1"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";font:300 normal 0.875rem/1.5rem ", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ",sans-serif;letter-spacing:0.0125rem;margin:0;text-align:center;");
const ProcessStageTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1lu622w2"
})(Typography/* Headline4 */.Ou, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";text-align:center;margin:0;");
const ProcessTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "e1lu622w3"
})(Typography/* Header3 */.BB, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";margin:0 0 1.25rem 0;text-align:center;letter-spacing:unset;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject8(), theme/* THEME.colors.light_grey */.C.colors.light_grey)), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";");
const ProcessSubtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1lu622w4"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-size:1rem;line-height:1.5rem;font-weight:300;max-width:18.8125rem;letter-spacing:0.0125rem;margin:0 auto 3.5rem auto;text-align:center;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject11())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject12())), ";");
const ProcessProgressContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1lu622w5"
})("display:grid;grid-template-columns:327px;grid-template-rows:1fr;justify-content:center;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject13())), ";");
const ProcessProgress = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1lu622w6"
})(mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject14())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject15())), ";");

;// CONCATENATED MODULE: ./components/sections/OurProcess/OurStages/ProcessStage.tsx


const ProcessStage = (param)=>{
    let { position , index , stageKey , title , image , stageDescription  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StageWrapper, {
        position: position,
        imageUrl: image.url,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessStageText, {
                children: stageDescription
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessStageTitle, {
                children: title
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/OurProcess/OurStages/ProcessStages.tsx



const ProcessStages = (param)=>{
    let { items , stageKey  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "our-develop-process__stages our-develop-process__stages ".concat(stageKey),
        children: items.map((item, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessStage, {
                index: index,
                position: item.position,
                title: prismic_reactjs.RichText.asText(item.title),
                image: item.image,
                stageDescription: prismic_reactjs.RichText.asText(item.description),
                stageKey: stageKey
            }, prismic_reactjs.RichText.asText(item.title)))
    });
};

;// CONCATENATED MODULE: ./components/sections/OurProcess/OurStages/processStage.types.ts
var StageKey;
(function(StageKey) {
    StageKey["TOP"] = "top";
    StageKey["BOTTOM"] = "bottom";
})(StageKey || (StageKey = {}));

// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
;// CONCATENATED MODULE: ./components/sections/OurProcess/OurProcess.tsx









const OurProcess = (param)=>{
    let { title , subtitle , items , id , children , titleAs  } = param;
    const { medium  } = (0,useWindowSize/* useWindowSize */.i)();
    const topProcesses = items.filter((item, index)=>item.position === "TOP");
    const bottomProcesses = items.filter((item, index)=>item.position === "BOTTOM");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "product-design__our-design-process our-design-process",
        id: id,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "product-design__our-design-process-wrapper ".concat(medium ? "desktop" : "mobile"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessTitle, {
                        as: titleAs,
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessSubtitle, {
                        children: prismic_reactjs.RichText.asText(subtitle)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessProgress, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProcessProgressContainer, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessStages, {
                                    items: topProcesses,
                                    stageKey: StageKey.TOP
                                }),
                                medium ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(horizontal_wave, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(vertical_wave, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessStages, {
                                    items: bottomProcesses,
                                    stageKey: StageKey.BOTTOM
                                })
                            ]
                        })
                    })
                ]
            }),
            children
        ]
    });
};


/***/ })

}]);